"use client";

import { MapPin, Ticket, StarIcon, Heart, Clock, Info, Users, Hourglass } from "lucide-react";
import { useRouter } from "next/navigation";
import Image from "next/image";
import { Eventi } from "@/types/globals";
import unitedkingdom from "@/images/unitedkingdom.png";
import france from "@/images/france.png";
const ColoredHeart = ({
  commissions
}: {
  commissions: "LOW" | "MEDIUM" | "HIGH";
}) => {
  if (commissions === "LOW") {
    return <Heart color="red" size={10} fill="red" />;
  }
  if (commissions === "MEDIUM") {
    return <Heart color="red" size={14} fill="red" />;
  }
  return <Heart color="red" size={18} fill="red" data-sentry-element="Heart" data-sentry-component="ColoredHeart" data-sentry-source-file="NewEventCard.tsx" />;
};
export default function EventCard({
  event
}: {
  event: Eventi;
}) {
  const router = useRouter();
  const imageUrl = event.imageStorageId;
  return <div onClick={() => router.push(`/event/${event.eventId}`)} className="grid lg:grid-cols-5 gap-2 rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-200 cursor-pointer overflow-hidden relative space-x-2 mb-2" data-sentry-component="EventCard" data-sentry-source-file="NewEventCard.tsx">
        <div className="col-span-2  grid bg-slate-50 lg:bg-white grid-cols-5">
          
          <div className="relative w-14 h-14 lg:h-full lg:w-28">
            {imageUrl && <Image src={imageUrl} alt={event.name || ""} fill className="object-fill" priority />}
            <div className="absolute bottom-1 right-1 bg-gradient-to-t ">
              <ColoredHeart commissions={event.event_commissions} data-sentry-element="ColoredHeart" data-sentry-source-file="NewEventCard.tsx" />
            </div>
          </div>
          
          <div className="p-2 pl-8 ml-2 col-span-4">
            <div className="flex justify-start  ">
                <div className="flex flex-col items-start gap-2">
                  <h2 className="text-md font-bold text-gray-900">
                    {event.name}
                  </h2>
                  <div className="flex items-center text-gray-600">
                    <StarIcon className="w-4 h-4 mr-2" data-sentry-element="StarIcon" data-sentry-source-file="NewEventCard.tsx" />
                    <span>{event.eventStar.toFixed(1)}</span>
                  </div>
                </div>
            </div>
            <p className="mt-2 text-gray-600 text-base line-clamp-2">
              {event.description}
            </p>
          </div>
          
        </div>

        <div className="space-y-1  content-around col-span-2">
          <div className="flex items-center text-gray-900 font-semibold justify-star">
            <Info className="mr-2 w-4 " size={18} data-sentry-element="Info" data-sentry-source-file="NewEventCard.tsx" />
            <span className="w-full">{event.synthesis}</span>
          </div>
          <div className="flex gap-2 justify-start">
            <div className="flex items-center text-gray-600">
              <Users className="w-4 h-4 mr-2" data-sentry-element="Users" data-sentry-source-file="NewEventCard.tsx" />
              <span>{event.customer_description}</span>
            </div>
            {event.event_languages && event.event_languages.includes('fr') && <div className="flex items-center text-gray-600">
                        <Image src={france} alt="logo" className="h-4 w-4" />
            </div>}
            {event.event_languages && event.event_languages.includes('en') && <div className="flex items-center text-gray-600">
                        <Image src={unitedkingdom} alt="logo" className="h-4 w-4" />
            </div>}
          </div>
          <div className="flex items-center text-gray-600">
            <MapPin className="w-4 h-4 mr-2" data-sentry-element="MapPin" data-sentry-source-file="NewEventCard.tsx" />
            <span className="bg-slate-50 rounded-sm border px-1 mb-1">{event.neighborhood}</span>
          </div>
        </div>

        <div className=" content-around p-1 space-y-1">
          <div className="flex items-center text-gray-900 font-semibold">
            <Ticket className="w-4 h-4 mr-2" data-sentry-element="Ticket" data-sentry-source-file="NewEventCard.tsx" />
            <span>A partir de {event.startingPrice.toFixed(0)} €</span>
          </div>
          <div className="flex items-center text-gray-600">
            <Clock className="w-4 h-4 mr-2" data-sentry-element="Clock" data-sentry-source-file="NewEventCard.tsx" />
            <span>{event.event_starts}</span>
          </div>
          <div className="flex items-center text-gray-600">
            <Hourglass className="w-4 h-4 mr-2" data-sentry-element="Hourglass" data-sentry-source-file="NewEventCard.tsx" />
            <span>{event.duration}</span>
          </div>
        </div>
      </div>;
}